<template>
    <a :href="business ? BUSINESS_TERMS_URL : CONSUMER_TERMS_URL" target="_blank" rel="noopener noreferrer"><slot>Terms of Service</slot></a>
</template>

<script setup lang="ts">
/**
 * The terms link every checkout surface renders. Which agreement a buyer signs depends on
 * who is buying, so the URL lives here once: a surface says `business` and cannot name the
 * wrong document. The short `/terms` redirects to the business one; link the destination
 * and skip the hop.
 */
const CONSUMER_TERMS_URL = 'https://privacybee.com/terms-of-service/';
const BUSINESS_TERMS_URL = 'https://business.privacybee.com/terms-of-service/';

withDefaults(defineProps<{ business?: boolean }>(), { business: false });
</script>
